










import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormTextDto } from '@/api';
import Placeholder from '@/views/account/Placeholder.vue';

@Component({
  components: {Placeholder},
})
export default class FormTextField extends Vue {

  @Prop({required: true, default: ''})
  private value!: string;

  @Prop({required: true})
  private formTextDto!: FormTextDto;

  public onChange(event: any) {
    this.$emit('input', event.target.value);
  }

  get label(): string {
    return this.formTextDto.label;
  }

  get fieldRequired(): boolean {
    return this.formTextDto.required;
  }

  get regex(): string | undefined {
    return this.formTextDto.regex;
  }

  get isMultiline(): boolean {
    return !!this.formTextDto.multiline;
  }
}
